module.exports = __webpack_public_path__ + "static/media/rugby.509ec0d0.svg";